import { render, staticRenderFns } from "./Music.vue?vue&type=template&id=40ed91ef&scoped=true"
import script from "./Music.vue?vue&type=script&lang=js"
export * from "./Music.vue?vue&type=script&lang=js"
import style0 from "./Music.vue?vue&type=style&index=0&id=40ed91ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed91ef",
  null
  
)

export default component.exports